import { ComplainControlContainer } from '../ComplainControlContainer';
import { DownloadDOCControlContainer } from '../DownloadDOCControlContainer';
import { DownloadPDFControlContainer } from '../DownloadPDFControlContainer';
import { FavoriteButtonContainer } from '../FavoriteButtonContainer';
import { HideFromPrintContainer } from '../HideFromPrintContainer';
import { NoteControlContainer } from '../NoteControlContainer';
import { ShowOnMapControlContainer } from '../ShowOnMapControlContainer';
import { ControlsLayout } from 'shared/components/Controls/ControlsLayout';

interface IProps {
  isHovered: boolean;
  hideFromPrintClick: () => void;
}

export const ControlsContainer = ({ isHovered, hideFromPrintClick }: IProps) => {
  return (
    <ControlsLayout>
      <FavoriteButtonContainer />
      <ComplainControlContainer isHovered={isHovered} />
      <ShowOnMapControlContainer isHovered={isHovered} />
      <HideFromPrintContainer isHovered={isHovered} onClick={hideFromPrintClick} />
      <DownloadPDFControlContainer isHovered={isHovered} />
      <DownloadDOCControlContainer isHovered={isHovered} />
      <NoteControlContainer isHovered={isHovered} />
    </ControlsLayout>
  );
};
